// extracted by mini-css-extract-plugin
export default {"limboTablesWrap":"styles_limboTablesWrap__FMXWa","limboTableMyBetsWrap":"styles_limboTableMyBetsWrap__S4Tta"};